import { useEffect, useLayoutEffect, type RefObject } from "react";

/** A text box as tall as its text (help centre round five, the founder: "one scrollbar" in the article editor): it never scrolls on its
 *  own, so the page around it is the one thing that scrolls. Measured again when the text changes and when the box changes width (wrapping
 *  changes with it); a hidden box measures nothing and keeps its height. */
export function useFitHeight(ref: RefObject<HTMLTextAreaElement | null>, value: string): void {
  const fit = () => {
    const el = ref.current;
    if (!el || el.clientWidth === 0) return;
    el.style.overflowY = "hidden";
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight + (el.offsetHeight - el.clientHeight)}px`;
  };
  useLayoutEffect(fit, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    let width = el.clientWidth;
    const ro = new ResizeObserver(() => { if (el.clientWidth !== width) { width = el.clientWidth; fit(); } });
    ro.observe(el);
    return () => ro.disconnect();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
